import React, { useEffect, useState, useContext } from 'react'
import { Button, Col, Divider, Drawer, Input, Radio, Row, Select, Typography, message } from 'antd'
import Utils from '../../../utils/Utils'
import { Context } from '../../../context'

const { Title } = Typography
const { Option } = Select

function EnterpriseDrawer(props) {
  const [{ auth }, dispatch] = useContext(Context)
  const [name, setName] = useState('')
  const [businessName, setBusinessName] = useState('')
  const [regime, setRegime] = useState('')
  const [nit, setNit] = useState(null)
  const [phone, setPhone] = useState(null)
  const [country, setCountry] = useState(null)
  const [currency, setCurrency] = useState(null)
  const [address, setAddress] = useState('')
  const [allowCreateProducts, setAllowCreateProducts] = useState(false)
  const [allowCreateShops, setAllowCreateShops] = useState(false)
  const [allowCreateUsers, setAllowCreateUsers] = useState(false)
  const [allowElectronicInvoice, setAllowElectronicInvoice] = useState(false)
  const [allowDiscountLevels, setAllowDiscountLevels] = useState(false)
  const [allowQuotes, setAllowQuotes] = useState(false)
  const [allowProjects, setAllowProjects] = useState(false)
  const [allowCentralCatalog, setAllowCentralCatalog] = useState(false)
  const [subjectQuarterlyIsr, setSubjectQuarterlyIsr] = useState(false)
  const [ivaRetentionAgent, setIvaRetentionAgent] = useState(false)
  const [countries, setCountries] = useState(null)
  const [currencies, setCurrencies] = useState(null)

  const loadInformation = () => {
    setName(props.edit ? props.editData.name : '')
    setBusinessName(props.edit ? props.editData.reason : '')
    setRegime(props.edit ? props.editData.regime : '')
    setNit(props.edit ? props.editData.nit : null)
    setPhone(props.edit ? props.editData.phone : null)
    setAddress(props.edit ? props.editData.address : '')
    setCountry(props.edit ? props.editData.pais_id : null)
    setCurrency(props.edit ? props.editData.currency_id : null)

    setAllowCreateProducts(props.edit ? (props.editData.allow_add_products === 1 ? true : false) : false)
    setAllowCreateShops(props.edit ? (props.editData.allow_add_stores === 1 ? true : false) : false)
    setAllowCreateUsers(props.edit ? (props.editData.allow_add_users === 1 ? true : false) : false)
    setAllowElectronicInvoice(props.edit ? (props.editData.allow_fel === 1 ? true : false) : false)
    setAllowDiscountLevels(props.edit ? (props.editData.allow_discount_levels === 1 ? true : false) : false)
    setAllowQuotes(props.edit ? (props.editData.allow_quotes === 1 ? true : false) : false)
    setAllowProjects(props.edit ? (props.editData.allow_projects === 1 ? true : false) : false)
    setAllowCentralCatalog(props.edit ? (props.editData.visible_central_catalog === 1 ? true : false) : false)
    setSubjectQuarterlyIsr(props.edit ? !!props.editData.subject_quarterly_isr : false)
    setIvaRetentionAgent(props.edit ? !!props.editData.iva_retention_agent : false)
  }

  useEffect(() => {
    loadInformation()

    if (props.visible) {
      onSearchCountry(props.edit ? props.editData.pais : '')
      onSearchCurrency(props.edit ? props.editData.currency_name : '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const saveData = () => {
    let data = {
      name: validateParams(name, 'Nombre') ? name : undefined,
      reason: validateParams(businessName, 'Razón social') ? businessName : undefined,
      regime,
      nit: validateParams(nit, 'NIT', false) ? nit : undefined,
      phone: validateParams(phone, 'Teléfono', false, 'phone') ? phone : undefined,
      address: validateParams(address, 'Dirección') ? address : undefined,
      country_id: validateParams(country, 'País') ? country : undefined,
      currency_id: validateParams(currency, 'Moneda') ? currency : undefined,
      allow_add_products: allowCreateProducts ? 1 : 0,
      allow_add_stores: allowCreateShops ? 1 : 0,
      allow_add_users: allowCreateUsers ? 1 : 0,
      allow_fel: allowElectronicInvoice ? 1 : 0,
      allow_discount_levels: allowDiscountLevels ? 1 : 0,
      allow_quotes: allowQuotes ? 1 : 0,
      allow_projects: allowProjects ? 1 : 0,
      visible_central_catalog: allowCentralCatalog ? 1 : 0,
      subject_quarterly_isr: subjectQuarterlyIsr,
      iva_retention_agent: ivaRetentionAgent,
      company_id: props.edit ? props.editData.company_id : 0,
    }

    let boolValidate = true
    for (let k in data) {
      if (boolValidate) {
        if (k !== 'regime') {
          const d = data[k]
          d === '' || d === undefined || d === null ? (boolValidate = false) : (boolValidate = true)
        }
      }
    }

    if (boolValidate) {
      props.saveButton(data, props.edit)

      auth.company.allow_quotes = allowQuotes ? 1 : 0
      dispatch({
        type: 'AUTH FETCHED',
        payload: auth,
      })
    }
  }

  const validateParams = (val, strMessage, boolInteger = false, paramsMessage) => {
    if (val === '' || val === null) {
      if (boolInteger) {
        return !Number.isInteger(val * 1) || val * 1 <= 0 ? message.warning(strMessage) : true
      }
      return message.warning(`El campo ${strMessage} no debe estar vacío`)
    } else if (paramsMessage === 'phone') {
      if (Utils.validateNumber(phone)) {
        message.warning('El campo Teléfono solo acepta valores numéricos')
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  const onSearchCountry = val => {
    const strSearch = val === null || val === '' ? '' : val
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getCountryOption(strSearch, excludeChars, 'desc')
      .then(response => {
        setCountries(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de País')
      })
  }

  const onSearchCurrency = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getCurrenciesOption(val, excludeChars, 'desc')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de Moneda')
      })
  }

  return (
    <Drawer className={'entreprise-drawer'} placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
      <Row gutter={16}>
        <Title> {props.edit ? 'Editar empresa' : 'Nueva empresa'} </Title>
        <Divider className={'divider-custom-margins-users'} />
        {/*Fields section*/}
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={8} sm={8} md={8} lg={8}>
            <div className={'title-space-field'}>Nombre*</div>
            <Input value={name} onChange={value => setName(value.target.value)} placeholder={'Nombre'} size={'large'} />
          </Col>
          <Col xs={8} sm={8} md={8} lg={8}>
            <div className={'title-space-field'}>Razón social*</div>
            <Input
              value={businessName}
              onChange={value => setBusinessName(value.target.value)}
              placeholder={'Escribe la razón social'}
              size={'large'}
            />
          </Col>
          <Col xs={8} sm={8} md={8} lg={8}>
            <div className={'title-space-field'}>Régimen</div>
            <Input value={regime} onChange={value => setRegime(value.target.value)} placeholder={'Escribe el régimen'} size={'large'} />
          </Col>
        </Row>
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={6} sm={6} md={6} lg={6}>
            <div className={'title-space-field'}>NIT*</div>
            <Input value={nit} onChange={value => setNit(value.target.value)} placeholder={'Escribir NIT'} size={'large'} />
          </Col>
          <Col xs={6} sm={6} md={6} lg={6}>
            <div className={'title-space-field'}>Teléfono*</div>
            <Input value={phone} onChange={value => setPhone(value.target.value)} placeholder={'Escribir teléfono'} size={'large'} />
          </Col>
          <Col xs={6} sm={6} md={6} lg={6}>
            <div className={'title-space-field'}>País*</div>
            <Select
              showSearch
              optionFilterProp="children"
              className={'single-select'}
              placeholder={'Elegir país'}
              size={'large'}
              style={{ width: '100%' }}
              value={country}
              onChange={value => setCountry(value)}
              onSearch={onSearchCountry}
              getPopupContainer={trigger => trigger.parentNode}
            >
              {countries &&
                countries.map(data => {
                  return (
                    <Option key={data.id} value={data.id}>
                      {data.name}
                    </Option>
                  )
                })}
            </Select>
          </Col>
          <Col xs={6} sm={6} md={6} lg={6}>
            <div className={'title-space-field'}>Moneda*</div>
            <Select
              showSearch
              optionFilterProp="children"
              className={'single-select'}
              placeholder={'Elegir moneda'}
              size={'large'}
              style={{ width: '100%' }}
              value={currency}
              onChange={value => setCurrency(value)}
              onSearch={onSearchCurrency}
              getPopupContainer={trigger => trigger.parentNode}
            >
              {currencies &&
                currencies.map(data => {
                  return (
                    <Option key={data.id} value={data.id}>
                      {data.name}
                    </Option>
                  )
                })}
            </Select>
          </Col>
        </Row>
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className={'title-space-field'}>Dirección*</div>
            <Input value={address} onChange={value => setAddress(value.target.value)} placeholder={'Escribir dirección'} size={'large'} />
          </Col>
        </Row>

        {/*End Fields section*/}

        {/*Radio button section*/}
        {auth.role_id <= 1 && (
          <>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Podrá crear sus propios productos y presentaciones?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowCreateProducts}
                  onChange={value => setAllowCreateProducts(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Podrá crear propias tiendas?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowCreateShops}
                  onChange={value => setAllowCreateShops(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Podrá crear sus propios usuarios?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowCreateUsers}
                  onChange={value => setAllowCreateUsers(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Facturará de forma electrónica?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  disabled={props.edit}
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowElectronicInvoice}
                  onChange={value => setAllowElectronicInvoice(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Sujeto a pagos trimestrales de ISR?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={subjectQuarterlyIsr}
                  onChange={value => setSubjectQuarterlyIsr(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Es agente de retención del IVA?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={ivaRetentionAgent}
                  onChange={value => setIvaRetentionAgent(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Manejará niveles de descuento?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowDiscountLevels}
                  onChange={value => setAllowDiscountLevels(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>{'¿Manejará cotizaciones?'}</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowQuotes}
                  onChange={value => setAllowQuotes(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>{'¿Manejará proyectos?'}</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowProjects}
                  onChange={value => setAllowProjects(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
            <Row gutter={16} className={'section-space-list'}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <span className={'label-bold-500 ratio-button-labels'}>¿Catalogo central visible?</span>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Radio.Group
                  disabled={props.edit}
                  className={'radio-group'}
                  optionType="button"
                  buttonStyle="solid"
                  size={'large'}
                  value={allowCentralCatalog}
                  onChange={value => setAllowCentralCatalog(value.target.value)}
                >
                  <Radio.Button value={false}>No</Radio.Button>
                  <Radio.Button value={true}>Sí</Radio.Button>
                </Radio.Group>
              </Col>
            </Row>
          </>
        )}
        {auth.role_id === 2 && <>
          <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>¿Manejará niveles de descuento?</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={allowDiscountLevels}
                onChange={value => setAllowDiscountLevels(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>{'¿Manejará cotizaciones?'}</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={allowQuotes}
                onChange={value => setAllowQuotes(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>{'¿Manejará proyectos?'}</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={allowProjects}
                onChange={value => setAllowProjects(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        </>}
      </Row>

      <Row gutter={16}>
        <Divider className={'divider-custom-margins-users'} />
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button type={'link'} className="cancel-button" onClick={() => props.cancelButton()}>
                Cancelar
              </Button>
              <Button htmlType="submit" className="title-tendero new-button" onClick={() => saveData()}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      {/*End Footer buttons section*/}
    </Drawer>
  )
}

export default EnterpriseDrawer
